import { Product } from "../../../../../graphql/operations";
import Money, { MoneyProps } from "../../../../Atoms/Money";
import styles from "../../Checkout.module.scss";

type GroupPriceDetailsProps = Pick<
  Product,
  "privatePrices" | "maximumInGroup"
> &
  Pick<MoneyProps, "currency">;

export default function GroupPriceDetails({
  privatePrices,
  maximumInGroup,
  currency,
}: GroupPriceDetailsProps) {
  return (
    <ul
      className={styles.BookingFormFieldsetFields}
      style={{ display: "flex", flexDirection: "column", gap: "32px" }}
    >
      {privatePrices.map((privatePrice, index) => {
        const nextPrice = privatePrices[index + 1];
        return (
          <li
            key={privatePrice.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <b>
              <Money amount={privatePrice.price} currency={currency} />
            </b>
            <div>
              groups of <b>{privatePrice.minGroupSize}</b> up to{" "}
              <b>{(nextPrice?.minGroupSize ?? maximumInGroup + 1) - 1}</b>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
